/**
 * CRM Sync CDR machine - replaces useCdrStore in use-crm-sync
 */
import { setup, assign } from 'xstate'

export interface CrmSyncCdrRecord {
  id: string
  caller: string
  callee: string
  type: 'voice' | 'video'
  duration: number
  status: 'completed' | 'missed' | 'failed' | 'busy' | 'no_answer'
  direction: 'inbound' | 'outbound'
  startTime: string
  endTime?: string
  queueId?: string
  memberId?: string
  memberName?: string
  customerId?: string
  recordingUrl?: string
}

export interface CrmSyncCdrContext {
  records: CrmSyncCdrRecord[]
  isLoading: boolean
  totalCount: number
}

export type CrmSyncCdrEvent =
  | { type: 'SET_RECORDS'; records: CrmSyncCdrRecord[]; total?: number }
  | { type: 'ADD_RECORD'; record: CrmSyncCdrRecord }
  | { type: 'SET_LOADING'; loading: boolean }
  | { type: 'CLEAR' }

const machineSetup = setup({
  types: { context: {} as CrmSyncCdrContext, events: {} as CrmSyncCdrEvent },
})

export const crmSyncCdrMachine = machineSetup.createMachine({
  id: 'crmSyncCdr',
  context: { records: [], isLoading: false, totalCount: 0 },
  on: {
    SET_RECORDS: {
      actions: assign(({ event }) =>
        event.type === 'SET_RECORDS'
          ? {
              records: event.records,
              totalCount: event.total ?? event.records.length,
            }
          : {}
      ),
    },
    ADD_RECORD: {
      actions: assign({
        records: ({ context, event }) =>
          event.type === 'ADD_RECORD' ? [event.record, ...context.records] : context.records,
        totalCount: ({ context, event }) =>
          event.type === 'ADD_RECORD' ? context.totalCount + 1 : context.totalCount,
      }),
    },
    SET_LOADING: {
      actions: assign({
        isLoading: ({ event }) => (event.type === 'SET_LOADING' ? event.loading : false),
      }),
    },
    CLEAR: {
      actions: assign({ records: [], totalCount: 0 }),
    },
  },
})
